export let apiConfigCommon = function () {
  return { baseURL: process.env.SH_SERVER }
}

export let apiConfigAuthenticated = function (
  token,
  ctype = 'application/json',
  rtype = 'json'
) {
  let baseConfig = apiConfigCommon()
  baseConfig.headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': ctype,
  }
  baseConfig.responseType = rtype
  return baseConfig
}



// WEBPACK FOOTER //
// ./src/api/config.js